import React from "react";
import { default as RBS_ModalBody, ModalBodyProps as RBS_ModalBodyProps } from "reactstrap/lib/ModalBody";
import classNames from "classnames";


export type ModalBodyProps = RBS_ModalBodyProps & {   
   compact?: boolean,
   withoutLeftRightPaddings?: boolean,
}

const ModalBody: React.FC<ModalBodyProps> = ({ compact = false, withoutLeftRightPaddings = false, className, ...rest }) => {
   return (<RBS_ModalBody {...rest} className={classNames({ "modal-body-compact": compact }, { "modal-body-no-left-right-paddings": withoutLeftRightPaddings}, className)} />)
}

export default ModalBody;